import axios, { AxiosRequestConfig } from "axios";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-CSRF":
      "aeEqBAF0MOYV0sAUqrkHKHE3ueaYUUzYCMWQeZZh6MoDF0qfbjIAcqfAFbYFYu6D",
  },
});

export const apiService = {
  get: async (url: string, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.get(url, config);
    return response.data;
  },

  getByQueryId: async (
    url: string,
    id: string,
    config?: AxiosRequestConfig,
  ) => {
    config = { ...config, params: { id } };
    const response = await axiosInstance.get(url, config);
    return response.data;
  },

  getByMultipleQueryParams: async (
    url: string,
    params: any,
    config?: AxiosRequestConfig,
  ) => {
    config = { ...config, params };
    const response = await axiosInstance.get(url, config);
    return response.data;
  },

  post: async (url: string, data?: any, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  },

  put: async (url: string, data?: any, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  },

  deleteByQueryId: async (
    url: string,
    id: string,
    config?: AxiosRequestConfig,
  ) => {
    config = { ...config, params: { id } };
    const response = await axiosInstance.delete(url, config);
    return response.data;
  },
  /*
  delete: async (url: string, data?: any, config?: AxiosRequestConfig) => {
    config = { ...config, params: { data } };
    const response = await axiosInstance.delete(url, config);
    return response.data;
  },
 */
  delete: async (url: string, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  },
};
